<template>
  <div v-cloak id="customer_list" class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>企業資料</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="customer-form col-md-12 align-self-center">
        <div class="row">
          <div class="col-md-3">
            <h4 class="col-md-6 fontSize16">統一編號:</h4>
            <input
              v-model="customerName"
              type="text"
              required="required"
              class="inputstyle col-md-6 fontSize14"
              disabled
            />
          </div>
          <div class="col-md-3">
            <h4 class="col-md-6 fontSize16">企業名稱:</h4>
            <input
              v-model="customerName"
              type="text"
              required="required"
              class="inputstyle col-md-6 fontSize14"
              disabled
            />
          </div>
          <div class="col-md-3">
            <h4 class="col-md-6 fontSize16">電子信箱:</h4>
            <input
              v-model="storeName"
              type="text"
              required="required"
              class="inputstyle col-md-6 fontSize14"
              disabled
            />
          </div>
          <div class="col-md-3">
            <h4 class="col-md-6 fontSize16">傳真電話:</h4>
            <input
              v-model="storeName"
              type="text"
              required="required"
              class="inputstyle col-md-6 fontSize14"
              disabled
            />
          </div>
          <div class="col-md-3">
            <h4 class="col-md-6 fontSize16">聯絡地址:</h4>
            <input
              v-model="storeName"
              type="text"
              required="required"
              class="inputstyle col-md-6 fontSize14"
              disabled
            />
          </div>
          <div class="col-md-3">
            <h4 class="col-md-6 fontSize16">聯絡人:</h4>
            <input
              v-model="storeName"
              type="text"
              required="required"
              class="inputstyle col-md-6 fontSize14"
              disabled
            />
          </div>
          <div class="col-md-3">
            <h4 class="col-md-6 fontSize16">聯絡人電話:</h4>
            <input
              v-model="storeName"
              type="text"
              required="required"
              class="inputstyle col-md-6 fontSize14"
              disabled
            />
          </div>
          <div class="col-md-3">
            <h4 class="col-md-6 fontSize16">每月結帳日:</h4>
            <input
              v-model="storeName"
              type="text"
              required="required"
              class="inputstyle col-md-6 fontSize14"
              disabled
            />
          </div>
          <div class="col-md-3">
            <h4 class="col-md-6 fontSize16">備註:</h4>
            <input
              v-model="storeName"
              type="text"
              required="required"
              class="inputstyle col-md-6 fontSize14"
              disabled
            />
          </div>
        </div>
      </div>
    </div>
    <hr />
    <SigningList></SigningList>
  </div>
</template>
<script>
import SigningList from '../../components/company/SigningList'

export default {
  components: {
    SigningList,
  },
  data() {
    return {
      signing: [
        {
          number: 120,
          callNumber: '123',
          driverName: '林聰明',
          onAddress: '上車地點',
          offAddress: '下車地點',
          type: '預約單',
          price: 100,
          isRequest: false,
          isAllowInspect: false,
        },
      ],
    }
  },
  methods: {
    getYearOptions() {
      this.years.push(moment().year())
      if (moment().month() - 5 < 0) {
        this.years.push(moment().year() - 1)
      }
      this.getMonthOptions()
    },
    getMonthOptions() {
      this.months = []
      if (this.year == moment().year()) {
        for (var i = 0; i < 6; i++) {
          var month = moment().subtract(i, 'month').month() + 1
          if (month <= moment().month() + 1) {
            this.months.push(month)
          }
        }
      } else {
        for (var i = 0; i < 6; i++) {
          var month = moment().subtract(i, 'month').month() + 1
          if (month > moment().month() + 1) {
            this.months.push(month)
          }
        }
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/company/CompanyDetail.vue